export default __webpack_public_path__ + "static/media/currybox3.630b2948.png";